// extracted by mini-css-extract-plugin
export default {"Root":"FileUploader_Root__SPDBo","Label":"FileUploader_Label__Fn0yc","Input":"FileUploader_Input__DuZQk","Preview":"FileUploader_Preview__mCTWf"};